"use client";
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Box } from "@mui/material";
import { Text } from "../../DataDisplay/Text/index.js";
import { COMPONENT_NAME } from "./constants.js";
import { StyledAccordion, StyledAccordionSummary, StyledChevron, StyledAccordionDetails } from "./styles.js";
import { getDataTestId } from "../../Util/index.js";
const DefaultContent = () => {
  return /* @__PURE__ */ jsx(Fragment, { children: "Insert details here" });
};
const Accordion = forwardRef(
  ({
    accordionSx = {},
    accordionDetailsSx = {},
    accordionSummarySx = {},
    adornment,
    ariaDescribedBy,
    ariaLabel,
    children = /* @__PURE__ */ jsx(DefaultContent, {}),
    displayTitle = true,
    expandIconSx = {},
    isExpanded,
    onBlur,
    onChange,
    onFocus,
    onMouseEnter,
    onMouseLeave,
    secondaryComponent,
    textComponent,
    title = "Title",
    uniqueId,
    variant,
    headingSlotTag = "h2"
  }, ref) => {
    if (children === /* @__PURE__ */ jsx(DefaultContent, {}) || displayTitle && title === "Title") {
      console.error(
        COMPONENT_NAME + "-error: Component default values present"
      );
    }
    return /* @__PURE__ */ jsxs(
      StyledAccordion,
      {
        "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
        expanded: isExpanded,
        onBlur,
        onChange,
        onFocus,
        onMouseEnter,
        onMouseLeave,
        ref,
        sx: accordionSx,
        slotProps: { heading: { component: headingSlotTag } },
        children: [
          /* @__PURE__ */ jsxs(
            StyledAccordionSummary,
            {
              "aria-describedby": ariaDescribedBy,
              "aria-label": ariaLabel,
              component: "button",
              expandIcon: /* @__PURE__ */ jsx(StyledChevron, { sx: expandIconSx }),
              id: uniqueId,
              sx: accordionSummarySx,
              children: [
                adornment && /* @__PURE__ */ jsx(Box, { sx: { paddingTop: "2px" }, children: adornment }),
                displayTitle && /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", flexDirection: "column" }, children: [
                  /* @__PURE__ */ jsx(
                    Text,
                    {
                      variant,
                      component: textComponent,
                      bold: true,
                      children: title
                    }
                  ),
                  secondaryComponent
                ] }),
                !displayTitle && /* @__PURE__ */ jsx(Fragment, { children: secondaryComponent })
              ]
            }
          ),
          /* @__PURE__ */ jsx(StyledAccordionDetails, { sx: accordionDetailsSx, children })
        ]
      }
    );
  }
);
Accordion.displayName = COMPONENT_NAME;
export {
  Accordion
};
